<template>
<div>
<div class="xinwen">
            <!--top-->
            <div class="top">
                 <Nav></Nav>
                <!--banner-->
                <div class="banner">
                                        <div class="layui-carousel" id="test10">
                        <div class="layui-cen" carousel-item="">
                                                        <div>
                                                                <img src="@s/data/uploads/20180705/90766a702215abadac0e36b977b5b229.jpg">                             </div>
                                                    </div>
                    </div>
                </div>
                <!--banner-end-->
            </div>
            <!--top-end-->
            <!--xinwen-center-->
            <div class="xinwen-center">
                <div class="layui-tab">
                    <div class="layui-tab-a">
                        <ul class="layui-tab-title">
                                <li class="layui-this">
                                    搜索到如下相关信息
                                </li>
                        </ul>
                    </div>
                    <div class="layui-tab-content">
                        <div class="layui-tab-item layui-show">
                            <div id="news_list">
                                <p style="text-align: center;line-height: 1.2rem;" v-show="newsList.length == 0">很抱歉，没有找到相关的信息。</p>

                             <div class="layui-tab-item-cen" v-for="(item,i) in newsList" :key="i">
                                    <div class="layui-tab-item-cen-L">
                                        <a :href="'/detail?id='+item.id" target="_blank"><img :src="item.image" /></a>
                                    </div>
                                    <div class="layui-tab-item-cen-R">
                                        <a :href="'/detail?id='+item.id" target="_blank">
                                            <h5>{{item.title}}</h5></a>
                                        <a :href="'/detail?id='+item.id" target="_blank">
                                            <p>{{item.describe}}</p>
                                        </a>
                                        <a :href="'/detail?id='+item.id" target="_blank"><span>{{item.publishTime}}</span></a>
                                    </div>
                                </div>
                                                            </div>
                            <div id="g" class="duo" data-flag="1" data-page="1" style="cursor:pointer;">查看更多</div>
                        </div>
                    </div>

                </div>
            </div>
            <!--xinwen-center-end-->

           <Footer></Footer>
        </div>

    <Backtop></Backtop>
</div> 
</template>

<script>
import Nav from '@c/Main/Nav/index.vue'
import Footer from '@c/Main/Footer/index.vue'
import Backtop from '@c/Main/Backtop/index.vue'
import { newsList } from '@/Apis/functions/user'
export default {
    name: "search",
    components: { Nav, Footer, Backtop },
    data(){
        return {
            newsList:[],
            limit:10,
            offset:0
        }
    },
    methods:{
        getList(page,fn){
            newsList({
              merchantId: 'dwj',
              keyword: this.$route.query.keyword,
              offset:(page-1) * this.limit,
              limit:this.limit
            }).then(result => {
                if(result.status==200){
                    this.newsList = this.newsList.concat(result.data)
                    if(result.data.length < this.limit){
                        $('#g').attr('data-flag',0).html('没有更多了！');
                    }
                    fn && fn()
                }
            })
        }
    },
    mounted(){
        this.getList(1)
        
       layui.use(['carousel', 'form'], function() {
            var carousel = layui.carousel
            carousel.render({
                elem: '#test10',
                width: '100%',
                height: '6.70rem',
                interval: 5000
            });
        })
        var _this = this
        $('.duo').click(function() {
            var page = $(this).attr('data-page');
            var flag = $(this).attr('data-flag');
            if(flag==1) {
                page++;
                $(this).attr('data-page',page);
                var index = layer.load();
                _this.getList(page,() => {
                    layer.close(index);
                })
            }
        });
    }

}
</script>

<style>
@import '~@/static/skin/web/css/xinwen.css';
@import '~@/static/skin/web/css/erji.css';
.xinwen-center .layui-tab .layui-tab-a .layui-tab-title{
    text-align: center;
}
.xinwen-center .layui-tab .layui-tab-a .layui-tab-title li{
    display: inline-block;
}
.layui-tab {
    background: none;
}
</style>